import { render } from "./InputContacts.vue?vue&type=template&id=b07ba15a"
import script from "./InputContacts.vue?vue&type=script&lang=js"
export * from "./InputContacts.vue?vue&type=script&lang=js"

import "./InputContacts.vue?vue&type=style&index=0&id=b07ba15a&lang=scss"
script.render = render

export default script